import React, { Component } from 'react'
import { Provider } from 'react-redux'
import './App.css'
import { CINEMA_UI_URL } from './common/config'
import { getAccessToken } from './common/util/helper'
import DefaultLayout from './layouts/defaultLayout'
import store from './store'
import './style/antd-override.less'
import './style/qw-css.less'
import './style/qw-theme.less'

class App extends Component {

  componentWillMount () {
    if (!getAccessToken()) {
      window.location = CINEMA_UI_URL
    }
  }

  render () {
    return (
      <Provider store={store}>
        <DefaultLayout/>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/app/App.js